module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/safari-pinned-tab-cfc4a2c98ae0696bcc7f4a44158c3d1b.svg";